import React, { createContext, useContext } from "react";

// 1. Import các file ngôn ngữ
import kr from "../assets/lang/kr.json";
import vi from "../assets/lang/vi.json";
// 2. Tạo Context
export const LanguageContext = createContext();

const translations = {
  kr,
  vi,
};

// 3. Tạo Provider Component
export const LanguageProvider = ({ children }) => {
  // Đọc ngôn ngữ mặc định từ biến môi trường
  // Đảm bảo tên biến môi trường phù hợp với cấu hình dự án của bạn (ví dụ: REACT_APP_DEFAULT_LOCALE)
  const defaultLocale = process.env.REACT_APP_DEFAULT_LOCALE || "vi";
  const messages = translations[defaultLocale];

  // Hàm dịch
  const translate = (key, params = {}) => {
    let text = messages;

    const parts = key.split(".");
    for (const part of parts) {
      if (text && typeof text === "object" && text.hasOwnProperty(part)) {
        text = text[part];
      } else {
        return key; // Trả về key nếu không tìm thấy bản dịch
      }
    }

    // Thay thế các tham số trong chuỗi dịch
    for (const [paramKey, paramValue] of Object.entries(params)) {
      text = text.replace(`{${paramKey}}`, paramValue);
    }
    return text;
  };

  return (
    <LanguageContext.Provider value={{ locale: defaultLocale, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 4. Tạo Custom Hook để dễ dàng sử dụng
export const useTranslation = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useTranslation must be used within a LanguageProvider");
  }
  return context;
};
